export default __webpack_public_path__ + "static/media/me3_Icon_PayAfterYouPass.4b30c3ca.svg";